import classNames from "classnames/bind";
import { InclusivelyHidden } from "../InclusivelyHidden/InclusivelyHidden";
import Link from "next/link";
import styles from "./ProjectList.module.css";
import { imageBuilder } from "../../sanity/lib/image";

const cx = classNames.bind(styles);

/**
 * A11y: We are manually adding `role=` back to all table elements,
 * because we disable accessibility when we set the CSS to `display: block/grid`
 */

export const ProjectList = ({
  items,
  projectNameLabel,
  yearLabel,
  locationLabel,
}: {
  items: { title: string; year: string; location: string; url: string; thumbnailUrl: string }[];
  projectNameLabel: string;
  yearLabel: string;
  locationLabel: string;
}) => (
  <table className={cx("container")} role="table">
    <thead className={cx("head")} role="rowgroup">
      <InclusivelyHidden as="tr" role="row">
        <th role="columnheader">{projectNameLabel}</th>
        <th role="columnheader">{yearLabel}</th>
        <th role="columnheader">{locationLabel}</th>
      </InclusivelyHidden>
    </thead>
    <tbody className={cx("body")} role="rowgroup">
      {items.map((item, index) => (
        <tr key={index} className={cx("row")} role="row">
          <td className={cx("title")} role="cell">
            <Link className={cx("link")} href={item.url}>
              {item.title}
            </Link>
            <img
              className={cx("image")}
              srcSet={[300, 600]
                .map((width) => {
                  const src = imageBuilder
                    .image(item.thumbnailUrl)
                    .format("webp")
                    .width(width)
                    .quality(90);
                  return `${src} ${width}w`;
                })
                .join(",\n")}
              loading="lazy"
              sizes="300px"
              src={item.thumbnailUrl}
              alt=""
            />
          </td>
          <td className={cx("year")} role="cell">
            {item.year}
          </td>
          <td className={cx("location")} role="cell">
            {item.location}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
